import { Injectable } from "@angular/core";
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from "@angular/router";
import { abort } from "process";

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem("userDetails")) {
            let siteurl: string = state.url;
            //let user = JSON.parse(localStorage.getItem('userDetails'));
            let dataresult = JSON.parse(localStorage.getItem("navUrlList"));
            for (var i = 0; i < dataresult.length; i++) {
                if (siteurl.includes(dataresult[i])) {
                    return true;
                } else if (
                    siteurl.includes("manageChargers") ||
                    siteurl.includes("overview") ||
                    siteurl.includes("viewChargerLog") ||
                    siteurl.includes("manageUserStation") ||
                    siteurl.includes("chargingProfile") ||
                    siteurl.includes("menuManagement") ||
                    siteurl.includes("miscellaneous") ||
                    siteurl.includes("tariffManagement")
                ) {
                    return true;
                }
            }
            return false;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigateByUrl("/login");
        return false;
    }
}
